import React from 'react';

type Caption = {
  text: string;
  hidden: boolean;
};

export function Caption({ text, hidden }: Caption) {
  if (!text) {
    return null;
  }
  return (
    <span
      className="media-information__caption"
      // If the user decides that the alt text for the image should be the same as the caption,
      // we hide the caption from the blind users via aria-hidden to avoid reading redundancy.
      // This is controlled in Figure.tsx.
      aria-hidden={hidden}
    >
      {text}
    </span>
  );
}
